export enum EAccordion {
  FAQ = 'faq',
}

export enum EAccordionClosingType {
  HEADER_CLICK = 'headerClick',
  FULL_CLICK = 'fullClick',
  ACTION_CLICK = 'actionClick',
}
